import { render, staticRenderFns } from "./LabelSiteFooter.vue?vue&type=template&id=196b6f61&scoped=true&"
import script from "./LabelSiteFooter.vue?vue&type=script&lang=js&"
export * from "./LabelSiteFooter.vue?vue&type=script&lang=js&"
import style0 from "./LabelSiteFooter.vue?vue&type=style&index=0&id=196b6f61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b6f61",
  null
  
)

export default component.exports